var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { setColor } from '../icon.utilities';
export function SAIconRedirect(_a) {
    var size = _a.size, colorVariant = _a.colorVariant, onClick = _a.onClick, icon = _a.icon, theme = _a.theme, additionalProps = __rest(_a, ["size", "colorVariant", "onClick", "icon", "theme"]);
    var iconTheme = useContext(ThemeContext);
    var color = setColor(iconTheme, colorVariant, 'primary');
    var renderSize = size !== null && size !== void 0 ? size : '100px';
    return (React.createElement("svg", __assign({}, additionalProps, { width: renderSize, height: renderSize, viewBox: "0 0 18 18", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }),
        React.createElement("path", { d: "M9.75 3C9.75 2.58579 10.0858 2.25 10.5 2.25H14.25C15.0784 2.25 15.75 2.92157 15.75 3.75V7.5C15.75 7.91421 15.4142 8.25 15 8.25C14.5858 8.25 14.25 7.91421 14.25 7.5V4.81103L8.78033 10.2807C8.48744 10.5736 8.01256 10.5736 7.71967 10.2807C7.42678 9.9878 7.42678 9.51293 7.71967 9.22004L13.1897 3.75L10.5 3.75C10.0858 3.75 9.75 3.41421 9.75 3ZM3.75 4.5C2.92157 4.5 2.25 5.17157 2.25 6V14.25C2.25 15.0784 2.92157 15.75 3.75 15.75H12C12.8284 15.75 13.5 15.0784 13.5 14.25V10.5C13.5 10.0858 13.1642 9.75 12.75 9.75C12.3358 9.75 12 10.0858 12 10.5V14.25H3.75V6H7.5C7.91421 6 8.25 5.66421 8.25 5.25C8.25 4.83579 7.91421 4.5 7.5 4.5H3.75Z", fill: color })));
}
//# sourceMappingURL=icon.redirect.component.js.map